import addEffectComposer from './EffectComposer';
import addOutlinePass from './OutlinePass';
import addRenderPass from './RenderPass';
import addShaderPass from './ShaderPass';

export {
    addShaderPass,
    addEffectComposer,
    addOutlinePass,
    addRenderPass
}

export default {
    addShaderPass,
    addEffectComposer,
    addOutlinePass,
    addRenderPass
}